import { render, staticRenderFns } from "./list.vue?vue&type=template&id=7c4bbe06&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style1 from "./list.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./list.vue?vue&type=style&index=2&id=7c4bbe06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4bbe06",
  null
  
)

export default component.exports